import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["copyButton"]
  static values = {
    target: String,
    text: String
  }

  connect() {
    // Save original HTML and classes of copy button for restoration
    if (this.hasCopyButtonTarget) {
      this.originalCopyText = this.copyButtonTarget.innerHTML
      // Detect and save original background color classes
      const bgClasses = Array.from(this.copyButtonTarget.classList).filter(cls => 
        cls.startsWith("bg-") && (cls.includes("sky") || cls.includes("purple") || cls.includes("indigo"))
      )
      this.originalBgClasses = bgClasses.length > 0 ? bgClasses : ["bg-sky-500", "hover:bg-sky-600"]
    } else {
      this.originalCopyText = null
      this.originalBgClasses = ["bg-sky-500", "hover:bg-sky-600"]
    }
  }

  async copy(event) {
    event.preventDefault()
    
    try {
      let textToCopy
      
      // Priority: text value > target selector > button text content
      if (this.hasTextValue) {
        textToCopy = this.textValue
      } else if (this.hasTargetValue) {
        // Get text from target element
        const targetElement = document.querySelector(this.targetValue)
        if (targetElement) {
          textToCopy = targetElement.value || targetElement.textContent || targetElement.innerText
        } else {
          console.warn(`Clipboard: Target element not found: ${this.targetValue}`)
          return
        }
      } else {
        // Fallback: try to get text from data attribute or text content
        textToCopy = this.element.dataset.text || this.element.textContent?.trim() || ""
      }
      
      if (!textToCopy) {
        console.warn("Clipboard: No text to copy")
        return
      }
      
      // Use Web Clipboard API
      await navigator.clipboard.writeText(textToCopy)
      
      // Visual feedback - same pattern as referral controller
      if (this.hasCopyButtonTarget) {
        const checkmarkIcon = `
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
          </svg>
        `
        
        this.copyButtonTarget.innerHTML = checkmarkIcon
        this.copyButtonTarget.classList.add("bg-green-600", "hover:bg-green-700")
        // Remove all background color classes
        this.copyButtonTarget.classList.remove(...this.originalBgClasses)
        
        setTimeout(() => {
          if (this.originalCopyText) {
            this.copyButtonTarget.innerHTML = this.originalCopyText
          }
          this.copyButtonTarget.classList.remove("bg-green-600", "hover:bg-green-700")
          // Restore original background classes
          this.copyButtonTarget.classList.add(...this.originalBgClasses)
        }, 2000)
      } else {
        // Fallback: change the button itself if no copyButton target
        this.showFeedbackOnElement(this.element)
      }
    } catch (error) {
      console.error("Clipboard: Failed to copy", error)
    }
  }
  
  showFeedbackOnElement(element) {
    const originalHTML = element.innerHTML
    const checkmarkIcon = `
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
      </svg>
    `
    
    element.innerHTML = checkmarkIcon
    element.classList.add("bg-green-600", "hover:bg-green-700")
    element.classList.remove("bg-sky-500", "hover:bg-sky-600")
    
    setTimeout(() => {
      element.innerHTML = originalHTML
      element.classList.remove("bg-green-600", "hover:bg-green-700")
      element.classList.add("bg-sky-500", "hover:bg-sky-600")
    }, 2000)
  }
}

